export default __webpack_public_path__ + "static/media/bx_bxl-linkedin.16f56c68.svg";